export default __webpack_public_path__ + "static/media/main-guy.08e1ecbc.png";